import { Auth } from "aws-amplify";
import Link from "next/link";
import Router from "next/router";
import { getPlaiceholder } from "plaiceholder";
import React from "react";
import { ThemeProvider } from "styled-components";
import Swal from "sweetalert2";
import LoginImage from "../../../shared/components/auth/LoginImage";
import AlertManager from "../../../shared/components/global/AlertManager";
import {
  LoginContainer,
  LoginForm,
  LoginGrid,
  Message,
} from "../../../shared/styles/authentication";
import { Button, ButtonSizes } from "../../../shared/styles/button";
import { Input, InputTextbox } from "../../../shared/styles/input";
import { Logo } from "../../../shared/styles/logo";
import Seo from "../components/global/Seo";
import { theme } from "../styles/theme";
import TalentpoolLogo from "/public/svg/Logo.svg";

const initialState = {
  email: ``,
  password: ``,
  authCode: "",
  stage: 0,
  error: "",
  loading: false,
};

interface ForgotPasswordPageProps {
  blurDataURL: any;
  img: any;
}

export default class ForgotPasswordPage extends React.Component<
  ForgotPasswordPageProps,
  any
> {
  state = initialState;

  handleUpdate = (event: any) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  forgotPassword = async () => {
    const { email } = this.state;
    this.setState({ loading: true });
    Auth.forgotPassword(email)
      .then(() => {
        this.setState({ stage: 1, error: "", loading: false });
      })
      .catch((err) => this.setState({ error: err.message, loading: false }));
  };

  confirmForgotPassword = async () => {
    const { email, authCode, password } = this.state;
    this.setState({ loading: true });
    try {
      await Auth.forgotPasswordSubmit(email, authCode, password);
      this.setState({ loading: false });
      Swal.fire(AlertManager.ForgotPasswordResetSuccess()).then(() => {
        Router.push("/login");
      });
    } catch (err: any) {
      this.setState({ error: err.message, loading: false });
    }
  };

  render() {
    const title = "Passwort vergessen";
    const description = "Passwort vergessen im Talentpool von easyboarding.";

    return (
      <ThemeProvider theme={theme}>
        <Seo title={title} description={description} />
        <section className="section-login">
          <LoginGrid>
            <LoginForm>
              <Logo>
                <Link href="/">
                  <a aria-label="Talentpool">
                    <TalentpoolLogo />
                  </a>
                </Link>
              </Logo>

              <div className="login-header">
                <h2>Passwort vergessen</h2>
              </div>
              {this.state.error && (
                <Message className="login-error-message">
                  <b>Passwort zurücksetzen fehlgeschlagen.</b>
                  <p>{this.state.error}</p>
                </Message>
              )}
              {this.state.stage === 0 && (
                <LoginContainer>
                  <div
                    style={{
                      maxWidth: 700,
                      width: "100%",
                      flexDirection: "column",
                      display: "flex",
                      rowGap: 15,
                    }}
                  >
                    <div className="login-input-container">
                      <InputTextbox>
                        <Input
                          id="email"
                          className={`${
                            this.state.email?.length > 0
                              ? "form-textbox-entered "
                              : ""
                          } form-textbox-input`}
                          onChange={this.handleUpdate}
                          name="email"
                          value={this.state.email}
                          type="email"
                        />
                        <span className="form-textbox-label">E-Mail</span>
                      </InputTextbox>
                    </div>
                    <Button
                      primary
                      type="button"
                      disabled={this.state.loading}
                      $loading={this.state.loading}
                      size={ButtonSizes.l}
                      onClick={this.forgotPassword}
                    >
                      Passwort zurücksetzen
                    </Button>
                  </div>
                </LoginContainer>
              )}
              {this.state.stage === 1 && (
                <LoginContainer>
                  <div
                    style={{
                      maxWidth: 700,
                      width: "100%",
                      flexDirection: "column",
                      display: "flex",
                      rowGap: 15,
                    }}
                  >
                    <div className="login-input-container">
                      <InputTextbox>
                        <Input
                          id="authCode"
                          className={`${
                            this.state.authCode?.length > 0
                              ? "form-textbox-entered "
                              : ""
                          } form-textbox-input`}
                          onChange={this.handleUpdate}
                          name="authCode"
                          value={this.state.authCode}
                          type="authCode"
                        />
                        <span className="form-textbox-label">
                          Bestätigungscode
                        </span>
                      </InputTextbox>
                    </div>
                    <div className="login-input-container">
                      <InputTextbox>
                        <Input
                          id="password"
                          className={`${
                            this.state.password?.length > 0
                              ? "form-textbox-entered "
                              : ""
                          } form-textbox-input`}
                          onChange={this.handleUpdate}
                          name="password"
                          value={this.state.password}
                          type="password"
                        />
                        <span className="form-textbox-label">Password</span>
                      </InputTextbox>
                    </div>
                    <Button
                      primary
                      type="button"
                      disabled={this.state.loading}
                      $loading={this.state.loading}
                      size={ButtonSizes.l}
                      onClick={this.confirmForgotPassword}
                    >
                      Neues Password erstellen
                    </Button>
                  </div>
                </LoginContainer>
              )}
            </LoginForm>
            <LoginImage
              img={this.props.img}
              blurDataURL={this.props.blurDataURL}
            />
          </LoginGrid>
        </section>
      </ThemeProvider>
    );
  }
}

export const getStaticProps = async () => {
  const { base64, img } = await getPlaiceholder("/images/login-cover.jpg", {
    size: 10,
  });

  return {
    props: {
      img: img.src,
      blurDataURL: base64,
    },
  };
};
